module.exports = __webpack_public_path__ + "static/media/Dev1.a4d86f9d.png";